module.exports = __webpack_public_path__ + "assets/img/exam_cbt_2025_ttl.fd809bf7.svg";